__turbopack_context__.v({
  "card": "image-card-module-scss-module__lUDaZq__card",
  "image": "image-card-module-scss-module__lUDaZq__image",
});
